import { SVGProps } from 'react';

export const ArrowUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='12'
    height='13'
    viewBox='0 0 12 13'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.73484 1.73483C5.88128 1.58839 6.11872 1.58839 6.26516 1.73483L10.0152 5.48484C10.1616 5.63128 10.1616 5.86872 10.0152 6.01516C9.86872 6.16161 9.63128 6.16161 9.48483 6.01516L6.375 2.90533V11C6.375 11.2071 6.20711 11.375 6 11.375C5.79289 11.375 5.625 11.2071 5.625 11V2.90533L2.51517 6.01516C2.36872 6.16161 2.13128 6.16161 1.98483 6.01516C1.83839 5.86872 1.83839 5.63128 1.98483 5.48484L5.73484 1.73483Z'
    />
  </svg>
);
